import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { trackGAEvent } from '../utilities/tracking'
import { FillerDiv } from '../StyledComponents/Fillers'
import {
    MainButtonWrapper,
    FABButtonIcon,
    FABButtonItemWrapper,
    FABButtonAction,
    FABButtonImage
} from '../StyledComponents/Global/FABButton'

import { CLASSIFIER } from '../../constants/routes'

const sensorImg = require('../../assets/images/DevicesList/sensor.png')

class FABButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
        }

        this.toggle = this.toggle.bind(this)
        this.openSearch = this.openSearch.bind(this)
        this.openFilter = this.openFilter.bind(this)
        this.setFavorite = this.setFavorite.bind(this)
        this.addToSensor = this.addToSensor.bind(this)
        this.openPlantRecognition = this.openPlantRecognition.bind(this)
    }

    setFavorite() {
        this.props.onFavoriteClicked()
        this.toggle()
    }

    toggle() {
        this.setState({ open: !this.state.open })
    }

    openSearch() {
        this.props.onSearchClicked()
        this.toggle()
    }

    openFilter() {
        this.props.onFilterClicked()
        this.toggle()
    }

    openPlantRecognition() {
        trackGAEvent('interaction', {
            interaction_value: 'undefined',
            interaction_category: 'Plant-List',
            interaction_action: 'fab-plant-recognition-click',
            interaction_label: 'open plant recognition',
        })
        this.props.history.push(CLASSIFIER)
    }

    addToSensor() {
        this.props.onAddSensorClicked()
        this.toggle()
    }

    renderItem(type, index) {
        let icon = null
        switch (type) {
            case 'search':
                icon = (
                    <FABButtonAction onClick={this.openSearch}>
                        <FABButtonIcon name="search" size="2x" />
                    </FABButtonAction>
                )
                break
            case 'visual-recognititon':
                icon = (
                    <FABButtonAction onClick={this.openPlantRecognition}>
                        <FABButtonIcon name="camera" size="2x" />
                    </FABButtonAction>
                )
                break
            case 'filter':
                icon = (
                    <FABButtonAction onClick={this.openFilter}>
                        <FABButtonIcon name="filter" size="2x" />
                    </FABButtonAction>
                )
                break
            case 'sensorAdd':
                icon = (
                    <FABButtonAction onClick={this.addToSensor}>
                        <FABButtonImage src={sensorImg} />
                    </FABButtonAction>
                )
                break
            case 'favorite':
                icon = (
                    <FABButtonAction onClick={this.setFavorite}>
                        <FABButtonIcon name="star" size="2x" />
                    </FABButtonAction>
                )
                break
            default:
        }

        return (
            <FABButtonItemWrapper index={index} key={type}>
                {icon}
            </FABButtonItemWrapper>
        )
    }

    render() {
        const { items } = this.props
        const { open } = this.state

        const buttons = open
            ? items.map((item, index) => this.renderItem(item, index))
            : null

        return (
            <FillerDiv>
                {buttons}
                <MainButtonWrapper open={open} onClick={this.toggle}>
                    <FABButtonIcon name={open ? 'times' : 'plus'} size="2x" />
                </MainButtonWrapper>
            </FillerDiv>
        )
    }
}

export default withRouter(FABButton)



// WEBPACK FOOTER //
// ./src/components/Global/FABButton.js